// extracted by mini-css-extract-plugin
export default {"title":"z5-z","warning":"A5-z","sizeOptionsLegendText":"B5-z"};